
import { Placement } from '@post-office/placements-frontend/nav-4-section';
export default Placement;
